import React from 'react'

import Box from 'app/components/base/Box'
import Pagination from 'app/components/base/Pagination'
import Stack from 'app/components/base/Stack'
import ReviewsCardRenderItem from 'app/features/Store/Reviews/components/ReviewsCardRenderItem'
import ReviewsEmptyState from 'app/features/Store/Reviews/components/ReviewsEmptyState'

import { useReviewList } from '../hooks/useReviewList'

type ReviewsListProps = {
  userId?: number
  slug: string
}

const ReviewsList: RFC<ReviewsListProps> = ({ userId, slug }) => {
  const {
    isEmpty,
    isPageLoading,
    reviews,
    showActionCards,
    showPagination,
    pages,
    setPage,
    paginationPage
  } = useReviewList({ userId, slug })

  return (
    <Stack spacing={4} sx={{ pt: { md: 6, xs: 5 }, width: '100%' }}>
      {isEmpty ? (
        <Box sx={{ py: 7 }}>
          <ReviewsEmptyState />
        </Box>
      ) : (
        reviews?.map((review) => (
          <ReviewsCardRenderItem
            key={review?.id}
            review={review}
            showAction={showActionCards}
            loading={isPageLoading}
          />
        ))
      )}

      {showPagination && (
        <Stack
          direction="row"
          sx={{
            justifyContent: 'center',
            mt: 5
          }}
        >
          <Pagination count={pages} page={paginationPage} onChange={setPage} />
        </Stack>
      )}
    </Stack>
  )
}

export default ReviewsList
